import styled from 'styled-components';
import banner from '../../assets/banner.jpg';
import coloricon from '../../styles/coloricon';

const {
  fontColor,
  secondaryColor,
  placeholderInputColor,
  backgroundInput,
  backgroundHeaderHover,
} = coloricon;

const imageChoosed = banner;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  background-image: url(${imageChoosed});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: calc(100vh - 100px - 80px);
`;

export const BannerArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: inherit;
  height: inherit;
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  min-height: calc(100vh - 100px - 80px);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 700px;
  align-items: center;
  text-align: center;
  padding: 0 10px;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 425px) {
    font-size: 14px;
  }

  @media (max-width: 375px) {
    font-size: 13px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
  }

  > h1 {
    text-align: center;
    margin-bottom: 10px;
  }

  > form {
    width: 80%;
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
  }

  a {
    display: flex;
    flex-direction: row;
    color: ${fontColor};
    transition: all 0.3s ease-in-out;
    align-items: center;
    justify-content: center;
    margin-bottom: 25px;
    font-size: 1.2em;

    svg {
      margin-right: 10px;
    }

    &:hover {
      color: ${secondaryColor};
    }
  }
`;

export const LogoArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 20px 0px;

  @media (max-width: 425px) {
    flex-direction: column;

    > img {
      margin-bottom: 10px;
    }
  }

  > img {
    width: 2.25em;
    height: 2.25em;
  }

  > h1 {
    font-size: 2em;
    margin-left: 5px;
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 2px;
  border-bottom: 1.5px solid ${placeholderInputColor};
  margin-bottom: 15px;
`;

export const OAuthArea = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  @media (max-width: 400px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const ButtonSocialMedia = styled.button`
  flex: 1;
  border: 0;
  outline: 0;
  height: 50px;
  margin: 0px 10px 30px 10px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  background-color: ${backgroundInput};

  @media (max-width: 400px) {
    padding: 20px 30px;
    width: 100%;
    margin: 10px 0px 10px 0px;
  }

  :hover {
    background-color: ${backgroundHeaderHover};
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    > svg {
      margin-right: 10px;
      color: ${fontColor};
    }
    > span {
      font-size: 1em;
      color: ${fontColor};
    }
  }
`;
